"use client";
import DatePicker from "@/components/primitives/date-picker";
import Select from "@/components/primitives/select";
import { ALL_WEEKS_OPTIONS, ALL_YEARS_OPTIONS } from "@/data/sports/nfl/options";
import { ALL_ODD_OPTIONS } from "@/data/sports/options";
import { formatServerDate } from "@/utils";
import { useQueryUpdater } from "@/utils/hooks/navigation";
import { Sport } from "common";
import { useRouter } from "next/navigation";
import React from "react";

export default function OddsPageFilter({
  sport,
  odds,
  week,
  year,
  date,
}: {
  sport: Sport | "all";
  odds: string;
  week?: string;
  year?: string;
  date?: string;
}) {
  const { createQueryParamString } = useQueryUpdater();
  const router = useRouter();
  return (
    <>
      <Select
        label="Select Odd"
        options={ALL_ODD_OPTIONS}
        defaultValue={odds}
        onValueChange={(v) =>
          router.push(createQueryParamString("odds", v), {
            scroll: false,
          })
        }
      />
      {sport === "nfl" && (
        <>
        <Select
          label="Select Week"
          options={ALL_WEEKS_OPTIONS}
          defaultValue={week}
          onValueChange={(v) =>
            router.push(createQueryParamString("week", v), {
              scroll: false,
            })
          }
        />
        <Select
          label="Select Year"
          options={ALL_YEARS_OPTIONS}
          defaultValue={year}
          onValueChange={(v) =>
            router.push(createQueryParamString("year", v), {
              scroll: false,
            })
          }
        />
        </>
      )}
      {(sport !== "nfl" && sport !== "all") && (
        <DatePicker
          mode="single"
          onValueChange={(v) =>
            router.push(createQueryParamString("date", formatServerDate(v)), {
              scroll: false,
            })
          }
        />
      )}
    </>
  );
}
